/* eslint-disable no-param-reassign */
import CodeMirror from 'codemirror';

(function () {
  'use strict';

  // plain
  // bracket
  // variable-name
  // bracket
  // unfinished-variable

  CodeMirror.defineMode('goformz-workflow', () => {
    return {
      startState() {
        return {
          previousType: null
        };
      },
      token(stream, state) {
        if (!stream) return null;

        // console.log(stream);
        // console.log(state);

        const peek = stream.peek();

        // #{
        if (stream.match(/^#{/, true)) {
          state.previousType = 'start-bracket';
          return 'bracket';
        }

        // variable-name
        if (state.previousType === 'start-bracket') {
          // detect if a new variable is starting before the current is closed
          if (stream.match(/^[^}]*?(?=#{)/, true)) {
            state.previousType = 'unfinished-variable';
            return 'unfinished-variable';
          }

          // detect if line ends before the current is closed
          if (stream.match(/^[^}]*$/, true)) {
            state.previousType = 'unfinished-variable';
            return 'unfinished-variable';
          }

          stream.match(/^[^}]*/);
          state.previousType = 'variable-name';
          return 'variable-name';
        }

        // }
        if (peek === '}' && state.previousType === 'variable-name') {
          stream.next();
          state.previousType = 'end-bracket';
          return 'bracket';
        }

        // match up until next variable
        if (stream.match(/^.*?(?=#{)/, true)) {
          state.previousType = 'plain';
          return 'plain';
        }

        // if there is no future variable on this line then match the rest to plain
        stream.match(/^.*/, true);
        state.previousType = 'plain';
        return 'plain';
      }
    };
  });
})();
